var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, FormControlLabel, Stack, FormLabel, RadioGroup, Radio } from '@mui/material';
import { RecordingMode } from './models';
var VideoSettingsEditor = /** @class */ (function (_super) {
    __extends(VideoSettingsEditor, _super);
    function VideoSettingsEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(VideoSettingsEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2 }, { children: [_jsx(FormLabel, { children: _jsx("h4", { children: "Recording Settings" }, void 0) }, void 0), _jsxs(RadioGroup, __assign({ onChange: function (e) { return _this.onRecordingModeChange(e); }, value: caseType === null || caseType === void 0 ? void 0 : caseType.recordingMode }, { children: [_jsx(FormControlLabel, { value: "0", control: _jsx(Radio, { color: "primary" }, void 0), label: "Disable" }, void 0), _jsx(FormControlLabel, { value: "1", control: _jsx(Radio, { color: "primary" }, void 0), label: "Video and audio" }, void 0), _jsx(FormControlLabel, { value: "2", control: _jsx(Radio, { color: "primary" }, void 0), label: "Audio only" }, void 0)] }), void 0), _jsx(FormControlLabel, { label: "Auto start recording when call starts", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", disabled: (caseType === null || caseType === void 0 ? void 0 : caseType.recordingMode) === RecordingMode.None, checked: caseType === null || caseType === void 0 ? void 0 : caseType.autoStartRecording, onChange: function (e) { return _this.onAutoStartRecordingChange(e); } }, void 0) }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(VideoSettingsEditor.prototype, "onRecordingModeChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var recordingMode = parseInt(e.target.value);
            if (!isNaN(recordingMode)) {
                var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
                if (caseType) {
                    var updatedCaseType = __assign(__assign({}, caseType), { recordingMode: recordingMode });
                    (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
                }
            }
        }
    });
    Object.defineProperty(VideoSettingsEditor.prototype, "onAutoStartRecordingChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { autoStartRecording: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    VideoSettingsEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], VideoSettingsEditor);
    return VideoSettingsEditor;
}(React.Component));
export default VideoSettingsEditor;
